import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router/index'
import { localGet } from './index'

// 这边由于后端没有区分测试和正式，姑且都写成一个接口。
axios.defaults.baseURL = '/api'//  http://localhost:8081 https://his.goldmanager.cn/t3_pos
// 携带 cookie，对目前的项目没有什么作用，因为我们是 token 鉴权
axios.defaults.withCredentials = true
// 请求头，headers 信息
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.Authorization = 'bearer ' + (localGet('token') == '' || localGet('token') == null ? '' : localGet('token').token_str)
// 默认 post 请求，使用 application/json 形式
axios.defaults.headers.post['Content-Type'] = 'application/json'

// 请求拦截器，内部根据返回值，重新组装，统一管理。
axios.interceptors.response.use(res => {
  if (res.data.code <= 0) {
    if (res.data.code != -799010) {
      ElMessage.error(res.data.msg)
    }
    return Promise.reject(res.data)
  }

  return res.data.result
}, error => {
  ElMessage.error('网络异常')
})

export default axios
